import { isTestEnv } from './is-test-env';

export const isInWix = () => {
  return isTestEnv || (typeof window !== 'undefined' && window.top !== window.self);
};
